module.exports = __webpack_public_path__ + "static/media/img_banner2.9b67bd38.svg";